export interface I_BetSenseModel {
  title: string;
  Name: string;
  Odd: any;
  marketName: string;
  NodeId: string;
}
